function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 85.1"
}, props), React.createElement("g", {
  fill: "none",
  stroke: "currentColor"
}, React.createElement("path", {
  strokeLinecap: "round",
  d: "M86.7 3.1l1.6 1.6m-4.1 2h2.9m-.5 3.9L88.3 9m2.3 3.8V9.9m0-6.5V.5m4 10.1L93 9m4.2-2.3h-2.9m.4-3.6L93 4.7m-4.1 68l1.6 1.6m-4.1 2.1h2.9m-.5 3.9l1.6-1.6m2.4 3.7v-2.9m0-6.4v-2.9m4 10.1l-1.6-1.6m4.2-2.3h-2.9m.4-3.7l-1.6 1.6m-92-53.9L4.9 22M.8 24h2.9m-.5 3.9l1.6-1.6m2.4 3.8v-2.9m0-6.5v-2.9m4 10.1l-1.6-1.6m4.2-2.3h-2.9m.4-3.6L9.6 22m2.7 52.5l1.6 1.6m-4.1 2.1h2.9m-.5 3.9l1.6-1.6m2.4 3.7v-2.9m0-6.4V72m4 10.1l-1.6-1.6m4.2-2.3h-2.9m.4-3.7l-1.6 1.6"
}), React.createElement("path", {
  d: "M68.5 50.4c-3.8.9-7.8 1.7-12 2.5-23.2 4.4-42.5 5.4-43.1 2.2-.3-1.8 5.1-4.5 14.5-7.4m51.9-9.9c10.3-.9 17.2-.4 17.6 1.4.4 2.3-9.1 6.2-23.2 9.8",
  strokeMiterlimit: "10",
  strokeWidth: "1.5"
}), React.createElement("circle", {
  cx: "54",
  cy: "44.7",
  r: "26.3",
  strokeWidth: "1.5",
  strokeMiterlimit: "10"
}), React.createElement("circle", {
  cx: "33.5",
  cy: "37.3",
  r: "1.8",
  strokeWidth: "1.5",
  strokeMiterlimit: "10"
}), React.createElement("circle", {
  cx: "33.1",
  cy: "42.9",
  r: "1.8",
  strokeWidth: "1.5",
  strokeMiterlimit: "10"
}), React.createElement("circle", {
  cx: "38",
  cy: "40.3",
  r: "1.8",
  strokeWidth: "1.5",
  strokeMiterlimit: "10"
}), React.createElement("circle", {
  cx: "71.4",
  cy: "49.8",
  r: "2.7",
  strokeWidth: "1.5",
  strokeMiterlimit: "10"
}))));